import React, { createContext, useContext } from "react";

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
 // Lock theme to light mode
 const theme = "light";
 
 // Remove any dark class if it somehow exists
 if (typeof document !== "undefined") {
 document.documentElement.classList.remove("dark");
 }

 const toggle = () => {}; // No-op

 return (
 <ThemeContext.Provider value={{ theme, toggle }}>{children}</ThemeContext.Provider>
 );
};

export const useTheme = () => {
 const ctx = useContext(ThemeContext);
 if (!ctx) throw new Error("useTheme must be used within ThemeProvider");
 return ctx;
};
